import { connect } from 'react-redux'
import { FeatureToggleComponent } from './FeatureToggleComponent'
import type { RootState } from 'shared/store/reducers'

const mapStateToProps = (state: RootState) => {
    const { available: availableFeatures } = state.featuresState

    return {
        availableFeatures
    }
}

const FeatureToggle = connect(mapStateToProps)(FeatureToggleComponent)

export { FeatureToggle }
